import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/ui/Toast';

/** Stop mouse-wheel from changing focused/hovered number fields (clients type values manually). */
document.addEventListener(
  'wheel',
  (event) => {
    const el = event.target;
    if (!(el instanceof HTMLInputElement)) return;
    if (el.type !== 'number') return;
    event.preventDefault();
  },
  { passive: false, capture: true }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
